import React, { useState, useEffect } from 'react';
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation';

import { renderHeaderTop }  from './ArticleUtils.js';

import { useParams } from "react-router-dom";

import { collection, query, where, getDoc, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from '../firebase';

function buildEntities(article) {
  const entities = [];
  if (article.awayTeamID && article.awayTeamName) {
    entities.push({ name: article.awayTeamName, url: `/teams/${article.awayTeamID}` });
  }
  if (article.homeTeamID && article.homeTeamName) {
    entities.push({ name: article.homeTeamName, url: `/teams/${article.homeTeamID}` });
  }
  (article.players || []).forEach(p => {
    if (p.id && p.name) {
      entities.push({ name: p.name, url: `/players/${p.id}` });
      const nameParts = p.name.split(' ');
      if (nameParts.length > 1) {
        const lastName = nameParts[nameParts.length - 1];
        if (lastName.length > 1) {
          entities.push({ name: lastName, url: `/players/${p.id}` });
        }
      }
    }
  });
  return entities;
}

function linkifyParagraph(text, entities) {
  const parts = [];
  let cursor = 0;

  while (cursor < text.length) {
    let bestIdx = Infinity;
    let bestEntity = null;

    for (const entity of entities) {
      const idx = text.indexOf(entity.name, cursor);
      if (idx === -1) continue;
      if (idx < bestIdx || (idx === bestIdx && entity.name.length > bestEntity.name.length)) {
        bestIdx = idx;
        bestEntity = entity;
      }
    }

    if (!bestEntity) {
      parts.push(text.slice(cursor));
      break;
    }

    if (bestIdx > cursor) {
      parts.push(text.slice(cursor, bestIdx));
    }

    parts.push({ url: bestEntity.url, text: bestEntity.name });
    cursor = bestIdx + bestEntity.name.length;
  }

  return parts;
}

const Article = () => {
  const routeParams = useParams();
  const article_id = routeParams.articleID;

  const [article, setArticle] = useState({});
  const [articleReady, setArticleReady] = useState(false);
  const [author, setAuthor] = useState({});

  useEffect(() => {
    getArticle(article_id);
  }, [])

  const getArticle = (article_id) => {
    const articleRef = doc(db, 'articles', article_id);

    getDoc(articleRef).then((doc) => {
      const data = doc.data();
      data.style = 'skinny'
      data.id = article_id
      // data.created_at = data.created_at.toDate()

      setArticle(data)
      setAuthor({
        bio: "When he's not raining threes from way beyond the Arc, this Angel is tracking every pass, pivot, and prayer on the court. Based in South Boston, Arc covers the League Morning Star with heavenly precision and a jump shot blessed by the skies.",
        name: "Arc Angel",
        image_url: "https://i0.wp.com/thecatholiccrusade.com/wp-content/uploads/2025/01/St-michael-the-archangel.png?fit=1080%2C1080&quality=80&ssl=1",
        profile_url: "https://en.wikipedia.org/wiki/Archangel",
        size: "md"
      });
      setArticleReady(true)
    })
  }



  const renderHeaderBottom = () => {
    let size = author.size;

    return (
      <div className={"article-header-bottom article-header-bottom-" + size }>
        <div className={"article-author article-author-" + size }>
          { size != 'sm'
            ? <img className={"author-image author-image-" + size } src={ author.image_url }/>
            : null
          }
          <div className="author-metadata">
            <p className={"author-title author-title-" + size } ><span>By</span> <span className="author-name"><a href={ author.profile_url }>{ author.name }</a></span></p>
            <p className="author-bio">{ author.bio }</p>
          </div>
        </div>
        { size != 'lg'
          ? <p className={"article-date article-date-" + size }>{ article.date_pulished }</p>
          : null
        }
      </div>
    );
  }

  if (articleReady == false) {
    return (
      <div className="Article">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Article">
        <div className="article-content">
          <div className="article-header">
            { renderHeaderTop(article) }
            { renderHeaderBottom() }
          </div>

          <div className="article-body">
            { (() => {
              const entities = buildEntities(article);
              return article.body.map((paragraph, index) => {
                const parts = linkifyParagraph(paragraph, entities);
                return (
                  <div key={"paragraph-" + index} className="article-paragraph">
                    <p>
                      {parts.map((part, i) =>
                        typeof part === 'string'
                          ? part
                          : <a key={i} href={part.url}>{part.text}</a>
                      )}
                    </p>
                  </div>
                );
              });
            })() }
          </div>

        </div>

        <Footer/>
      </div>
    );
  }
}

export default Article;
